/* iliac wishlist + recently viewed (device-local, no app required)
   Place in /assets/iliac-wishlist.js and load once in theme.liquid:
   <script src="{{ 'iliac-wishlist.js' | asset_url }}" defer></script>
*/
(function () {
  var WKEY = 'iliac:wishlist';
  var RKEY = 'iliac:recent';
  var RMAX = 8;

  function read(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var Wish = {
    all: function () { return read(WKEY); },
    has: function (h) { return this.all().indexOf(h) > -1; },
    toggle: function (h) {
      var list = this.all(); var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      write(WKEY, list); sync(); return i === -1;
    },
    remove: function (h) { var list = this.all().filter(function (x) { return x !== h; }); write(WKEY, list); sync(); },
    recent: function () { return read(RKEY); },
    pushRecent: function (h) {
      var list = read(RKEY).filter(function (x) { return x !== h; });
      list.unshift(h); if (list.length > RMAX) list = list.slice(0, RMAX);
      write(RKEY, list);
    }
  };
  window.IliacWishlist = Wish;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }

  /* Update all count badges + button states */
  function sync() {
    var count = Wish.all().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-on', count > 0);
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var on = Wish.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        Wish.toggle(btn.getAttribute('data-handle'));
      });
    });
  }

  /* Recently viewed: record the product on any /products/ page */
  function trackRecent() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m && m[1]) Wish.pushRecent(m[1]);
  }

  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var url = p.url || ('/products/' + p.handle);
    return '<article class="iwl-card">' +
      '<a class="iwl-card__media" href="' + url + '"><img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
      '<button class="iwl-card__remove" data-remove="' + p.handle + '" aria-label="Remove">&times;</button>' +
      '<div class="iwl-card__meta"><a class="iwl-card__title" href="' + url + '">' + (p.title || '') + '</a>' +
      '<div class="iwl-card__price">' + money(p.price) + '</div></div>' +
      '</article>';
  }

  function fetchProduct(h) {
    return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function renderGrid(handles, grid, done) {
    if (!grid) { if (done) done(0); return; }
    if (!handles.length) { grid.innerHTML = ''; if (done) done(0); return; }
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var live = products.filter(Boolean);
      grid.innerHTML = live.map(card).join('');
      grid.querySelectorAll('[data-remove]').forEach(function (b) {
        b.addEventListener('click', function () {
          Wish.remove(b.getAttribute('data-remove'));
          renderWishlistPage();
        });
      });
      if (done) done(live.length);
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-root]');
    if (!root) return;
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    renderGrid(Wish.all(), grid, function (n) {
      if (empty) empty.style.display = n > 0 ? 'none' : '';
    });
    var recentWrap = root.querySelector('[data-recent-wrap]');
    var recentGrid = root.querySelector('[data-recent-grid]');
    var recent = Wish.recent().filter(function (h) { return !Wish.has(h); });
    renderGrid(recent, recentGrid, function (n) {
      if (recentWrap) recentWrap.style.display = n > 0 ? '' : 'none';
    });
  }

  Wish.render = renderWishlistPage;

  function init() {
    trackRecent();
    bindButtons(document);
    sync();
    renderWishlistPage();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { bindButtons(document); sync(); renderWishlistPage(); });
})();
